import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=6ffd7a2c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffd7a2c"]])

export default __exports__